import { api } from "api/api";
import { AxiosError } from "axios";
import AtividadeApontamento from "model/gestao/atividades/AtividadeApontamento";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

export default class AtividadeMeusApontamentosService implements BaseServiceCadastros<AtividadeApontamento> {
    pesquisar(page: Pageable, filter?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/atividadeapontamento/meusApontamentos/pesquisar`;
            if (filter) {
                url += getFilters(filter)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/atividadeapontamento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    consultar(id: number | string, idConta?: number | null): Promise<AtividadeApontamento> {
        throw new Error("Method not implemented.");
    }
    incluir(model: AtividadeApontamento | FormData, idConta?: number | null): Promise<AtividadeApontamento> {
        throw new Error("Method not implemented.");
    }
    editar(model: AtividadeApontamento | FormData, idConta?: number | null): Promise<AtividadeApontamento> {
        throw new Error("Method not implemented.");
    }


}